import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import {
    BatchSpanProcessor,
    TracerConfig,
    WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { Resource } from '@opentelemetry/resources';
import { _getItemFromLocalDecrypted } from "network-helper";
import { clusterName, collectorEndpoint, serviceName } from '../config.json';
import { SessionIdProcessor } from './SessionIdProcessor';
const TracerInit = async () => {
    const collectorOptions = {
        url: collectorEndpoint, // <-- Jio Observability Traces Collector Endpoint.
    };
    const providerConfig: TracerConfig = {
        resource: new Resource({
            [SemanticResourceAttributes.SERVICE_NAME]: serviceName, // <-- Jio Observability Traces Service Name.
            'cluster': clusterName, // <-- Jio Observability Traces Cluster Name.
        }),
    };
    const provider = new WebTracerProvider(providerConfig);
    provider.addSpanProcessor(new SessionIdProcessor());
    provider.addSpanProcessor(
        new BatchSpanProcessor(new OTLPTraceExporter(collectorOptions)),
    );
    provider.register({
        contextManager: new ZoneContextManager(),
        propagator: new CompositePropagator({
            propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
        }),
    });
    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            getWebAutoInstrumentations({
                '@opentelemetry/instrumentation-fetch': {
                    // Disable propagation for the URLs which gives CORS Error. Use Regex
                    // propagateTraceHeaderCorsUrls: /^(?!https:\/\/maps\.googleapis\.com\/).*$/, 
                    propagateTraceHeaderCorsUrls: /.*/,
                    clearTimingResources: true,
                    applyCustomAttributesOnSpan(span) {
                        span.setAttribute('app.synthetic_request', 'false');
                    },
                },
                '@opentelemetry/instrumentation-xml-http-request': {
                    // Disable propagation for the URLs which gives CORS Error. Use Regex
                    // propagateTraceHeaderCorsUrls: /^(?!https:\/\/maps\.googleapis\.com\/).*$/, 
                    propagateTraceHeaderCorsUrls: /.*/,
                    clearTimingResources: true,
                }
            }),
        ],
    });
}
export default TracerInit;